import { render, staticRenderFns } from "./Pen.vue?vue&type=template&id=1a40099f&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Pen.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Pen.vue
// module id = 2242
// module chunks = 1